<template>
  <div class="survey_main_wrap">
    <div class="survey_main">
      <div class="survey_prefix_wrap">
        <div class="survey_title">
          <div
            :class="{'content_editable':true,'editable_focus':titlefocus}"
            tabindex="0"
            @focus.capture="titlefocus=true"
            @blur.capture="titlefocus=false"
          >
            <v-input
              v-model="surveyData.title"
              class="q-desc title_content"
              placeholder="点击填写题目描述"
            ></v-input>
          </div>
        </div>
        <div class="survey_prefix">
          <div
            :class="['content_editable',{'content_editable':true,'editable_focus':prefixfocus}]"
            tabindex="0"
            @focus.capture="prefixfocus=true"
            @blur.capture="prefixfocus=false"
          >
            <v-input
              v-model="surveyData.prefix"
              class="q-desc prefix_content"
              placeholder="点击编辑欢迎语"
            ></v-input>
          </div>
        </div>
        <div class="survey_limit">
          截止日期：
          <el-date-picker
            v-model="time"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            format="yyyy-MM-dd HH:mm"
            value-format="timestamp"
            :default-time="defaultTime"
            :picker-options="datePickerOptions"
            @change="setSurveyBodyTimeRange"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="survey_question_wrap">
        <draggable
          v-model="surveyData.questions"
          v-bind="{ group:'people', animation:300 }"
          @start="drag=true"
          @end="onDragEnd"
        >
          <question-card
            v-for="(item,index) in surveyData.questions"
            :key="index"
            :question="item"
            :index="index"
            @activeQue="questionSetting"
            @addmore="addmore"
          ></question-card>
        </draggable>
      </div>
      <div class="survey_suffix_wrap">
        <div class="survey_suffix">
          <div
            :class="['content_editable',{'content_editable':true,'editable_focus':suffixfocus}]"
            style="position: relative"
            tabindex="0"
            @focus.capture="suffixfocus=true"
            @blur.capture="suffixfocus=false"
          >
            <div
              class="suffix_content"
              contenteditable="true"
              tabindex="0"
              placeholder="点击编辑结束语"
              has-value="true"
            >
              您已完成本次问卷，感谢您的帮助与支持</div>
          </div>
        </div>
        <div class="release_share_box">
          <button
            class="save_btn temp"
            :disabled="surveyBody.questions.length<1"
            @click="save('editing')"
          >保存草稿</button>
          <button
            class="save_btn"
            :disabled="publishButtonDisabled"
            @click="handlePublish"
          >发布问卷</button>
        </div>
      </div>
    </div>
    <bubble></bubble>
  </div>
</template>

<script>
import QuestionCard from "./question-card";
import Draggable from "vuedraggable";
import Bubble from "./bubble";
import VInput from "./v-input";
import saveMixins from "../../mixins/saveMixins";
import { mapActions } from "vuex";
export default {
  mixins: [saveMixins],
  props: {
    surveyData: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      drag: false,
      titlefocus: false,
      prefixfocus: false,
      suffixfocus: false,
      time: [new Date().getTime()],
      datePickerOptions: {
        disabledDate: time => time.getTime() < Date.now() - 8.64e7
      }
    };
  },
  computed: {
    qlength: {
      get: function() {
        return this.$store.state.survey.surveyBody.questions.length;
      },
      set: function() {}
    },
    surveyBody: {
      get: function() {
        return this.$store.state.survey.surveyBody;
      },
      set: function() {}
    },
    publishButtonDisabled() {
      let questionsLen = this.surveyBody.questions.length < 1;
      let startAt =
        !this.surveyBody.started_at || (this.time ? !this.time[0] : true);
      let endedAt =
        !this.surveyBody.ended_at || (this.time ? !this.time[1] : true);
      return questionsLen || startAt || endedAt;
    },
    defaultTime() {
      return [
        `${new Date().getHours()}:${new Date().getMinutes()}:00`,
        "12:00:00"
      ];
    }
  },
  watch: {
    surveyBody(newVal) {
      this.time = [newVal.started_at || new Date().getTime(), newVal.ended_at];
    }
  },
  methods: {
    questionSetting(data) {
      this.$store.dispatch("setActiveQuestion", data.question);
      this.$store.dispatch("setActiveIndex", data.index);
    },

    addmore(lt) {
      const data = {
        left: lt.left + "px",
        top: lt.top + "px"
      };
      this.$store.dispatch("setBubbleParameter", data);
    },

    onDragEnd(event) {
      this.drag = false;
      this.$store.dispatch("updateLogicAfterDrag", [
        event.oldIndex,
        event.newIndex
      ]);
    },

    handlePublish() {
      let [startedAt, endedAt] = this.time;
      const now = new Date().getTime();
      if (endedAt <= now) {
        this.$message({
          type: "warning",
          center: true,
          message: "结束时间有误",
          duration: 1500
        });
        return;
      }
      if (startedAt <= now) {
        this.save("published");
      } else {
        this.save("stay");
      }
    },

    ...mapActions(["setSurveyBodyTimeRange"])
  },
  components: {
    QuestionCard,
    Draggable,
    Bubble,
    VInput
  }
};
</script>

<style lang="less" scoped>
@import "./survey.less";
</style>
